module.exports = __webpack_public_path__ + "img/gc_country_flag_cl.cc3a6e54.svg";